import React, { useEffect, useState } from 'react';
import { Form, Button, Select, message, Upload } from 'antd';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Option } = Select;
const API_URL = process.env.REACT_APP_API_URL;

const MassUploadUserRole: React.FC = () => {
  const [fileList, setFileList] = useState<any[]>([]);
  const { instance, accounts } = useMsal();

  const fetchToken = async () => {
    const res = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    return res.idToken;
  };

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.error('Please select a file to upload');
      return;
    }

    const roleSelected = selectedRole;
    if (!roleSelected) {
      message.error('Please select a role before uploading');
      return;
    }
    const file = fileList[0].originFileObj;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('roleSelected', roleSelected); // Append the selected role to the formData
  
    try {
      const token = await fetchToken();
      await axios.post(`${API_URL}/api/Roles/CustomUserRoleExcel`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });
      message.success('User roles uploaded successfully');
    } catch (error) {
      message.error('Failed to upload user roles');
    }
  };

  const handleChange = (info: any) => {
    setFileList(info.fileList.slice(-1));
  };
  const [roles, setRoles] = useState<{ customRoleId: string; customRoleName: string }[]>([]);
  const [selectedRole, setSelectedRole] = useState<string | undefined>(undefined);

  const fetchRoles = async () => {
    const token = await fetchToken();
    const response = await axios.get(`${API_URL}/api/Roles`,{
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
  useEffect(() => {
    const loadRoles = async () => {
      try {
        const rolesData = await fetchRoles();
        setRoles(rolesData);
      } catch (error) {
        message.error('Failed to load roles');
      }
    };
    loadRoles();
  }, []);


  useEffect(() => {
    const runningprocess = async () => {
      if (selectedRole) {
        console.log("the value selected is", selectedRole);
      }
    };
    runningprocess();
  }, [selectedRole]);


  return (
    <div>
      <Form layout="vertical">
      <Form.Item label="Select Role" required>
        <Select
            value={selectedRole}
            onChange={setSelectedRole}
            placeholder="Select a role"
          >
            {roles.map(role => (
              <Option key={role.customRoleId} value={role.customRoleId}>
                {role.customRoleName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Upload Excel/CSV File">
          <Upload
            accept=".xlsx,.csv"
            fileList={fileList}
            beforeUpload={() => false}
            onChange={handleChange}
          >
            <Button icon={<UploadOutlined />}>Select File</Button>
          </Upload>
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={handleUpload}>Upload</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default MassUploadUserRole;